export default "__VITE_ASSET__1225e8ab__"